import { render, staticRenderFns } from "./VideoCardDialog.vue?vue&type=template&id=5f5bbb84&scoped=true"
import script from "./VideoCardDialog.vue?vue&type=script&lang=ts"
export * from "./VideoCardDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5bbb84",
  null
  
)

export default component.exports